// Google Analytics 4 (GA4) helper for the public site.
// The gtag.js loader + config call live in public/index.html with send_page_view:false;
// this module sends one page_view event per route change (SPA navigation).
export const GA_MEASUREMENT_ID = 'G-3KH8H0PFL2';

export function trackPageView(path) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  window.gtag('event', 'page_view', {
    page_title: document.title,
    page_location: window.location.href,
    page_path: path,
  });
}
